export const UserExerciseTypeOf = "USER_EXERCISE"
export const ProgramExerciseTypeOf = "SESSION_EXERCISE"
export const BoxSlotExerciseTypeOf = "SLOT_EXERCISE"
export const allExerciseType = [UserExerciseTypeOf, ProgramExerciseTypeOf, BoxSlotExerciseTypeOf]

export const ExerciseCategories = [
  "WARM_UP",
  "SKILLS",
  "MOVEMAX_OD",
  "SPECIFIC_WOD",
  "WOD",
  "BODY_BUILDING",
  "MOBILITY",
  "OTHER",
] as const

export type ExerciseCategory = (typeof ExerciseCategories)[number]
